import { render, staticRenderFns } from "./question-inactive.component.html?vue&type=template&id=0cf785cb&scoped=true&external"
import script from "./question-inactive.component.ts?vue&type=script&lang=ts&external"
export * from "./question-inactive.component.ts?vue&type=script&lang=ts&external"
import style0 from "./question-inactive.component.scss?vue&type=style&index=0&id=0cf785cb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf785cb",
  null
  
)

export default component.exports